export const PROMO_CODE_PRE = 'VELOEMGMPRE'
export const PROMO_CODE_POS = 'VELOEMGMPOS'